/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import * as tslib_1 from "tslib";
import { GridCellBase } from "./GridCellBase";
import { Base, runOn, markType } from "igniteui-react-core";
import { stringIsNullOrEmpty } from "igniteui-react-core";
/**
 * @hidden
 */
var ImageCell = /** @class */ /*@__PURE__*/ (function (_super) {
    tslib_1.__extends(ImageCell, _super);
    function ImageCell(a) {
        var _this = _super.call(this, a) || this;
        _this.b9 = null;
        _this.b3 = 1;
        _this.b4 = 3;
        _this.cb = null;
        _this.b5 = false;
        _this.b6 = 1;
        _this.b8 = null;
        _this.b9 = a.createElement("img");
        _this.b9.listen("load", runOn(_this, _this.ce));
        _this.b8 = a.createElement("div");
        _this.b8.setRawStyleProperty("background-size", "contain");
        _this.b8.setRawStyleProperty("background-repeat", "no-repeat");
        _this.b8.setRawStyleProperty("background-position", "center");
        _this.b8.setRawStyleProperty("width", "100%");
        _this.b8.setRawStyleProperty("height", "100%");
        _this.z.setRawStyleProperty("text-align", "left");
        _this.z.setRawStyleProperty("vertical-align", "middle");
        _this.z.append(_this.b8);
        return _this;
    }
    Object.defineProperty(ImageCell.prototype, "ca", {
        get: function () {
            return this.b9;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(ImageCell.prototype, "b7", {
        get: function () {
            return this.b6;
        },
        set: function (a) {
            this.b6 = a;
        },
        enumerable: true,
        configurable: true
    });
    ImageCell.prototype.ce = function (a) {
        this.b5 = false;
        if (!stringIsNullOrEmpty(this.cb)) {
            this.b8.setRawStyleProperty("opacity", "1");
            this.b8.setRawStyleProperty("background-image", "url(" + this.cb + ")");
        }
    };
    ImageCell.prototype.cf = function (a, b) {
        if (a == this.cb) {
            return;
        }
        this.cc();
        this.b8.setRawStyleProperty("opacity", "0");
        if (a == null || a.length == 0) {
            this.cd(this.b9);
            return;
        }
        if (Base.equalsStatic(a, this.cb)) {
            return;
        }
        this.cj(a, b);
        var img_ = this.b9.getNativeElement();
        if (img_ != null && (img_.complete)) {
            this.b5 = false;
            this.b9.setRawStyleProperty("opacity", "1");
            this.b8.setRawStyleProperty("background-image", "url(" + this.cb + ")");
        }
    };
    ImageCell.prototype.cd = function (a) {
        a.setAttribute("src", "");
        this.b8.setRawStyleProperty("background-image", "");
    };
    ImageCell.prototype.ci = function (a) {
        switch (a) {
            case 1:
                this.b8.setRawStyleProperty("background-size", "100% 100%");
                break;
            case 2:
                this.b8.setRawStyleProperty("background-size", "auto");
                break;
            case 0:
                this.b8.setRawStyleProperty("background-size", "contain");
                break;
        }
    };
    ImageCell.prototype.cj = function (a, b) {
        this.b5 = true;
        this.cb = a;
        this.ca.setAttribute("src", a);
    };
    ImageCell.prototype.cc = function () {
        if (this.b5) {
            this.cd(this.b9);
            this.cb = "";
        }
    };
    ImageCell.prototype.cg = function (a) {
        this.b3 = a;
    };
    ImageCell.prototype.ch = function (a) {
        this.b4 = a;
    };
    ImageCell.prototype.get_r = function () {
        return true;
    };
    ImageCell.prototype.bd = function (a, b, c) {
        _super.prototype.bd.call(this, a, b, c);
        if (a == "Indent" || a == "IsCollapsable") {
            this.b8.setRawStyleProperty("margin-left", this.au + this.aw + this.av + "px");
        }
    };
    ImageCell.$t = markType(ImageCell, 'ImageCell', GridCellBase.$);
    return ImageCell;
}(GridCellBase));
export { ImageCell };
//# sourceMappingURL=ImageCell.js.map
